import React from "react";
import styled from "@emotion/styled";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useChartColors } from "@hooks";

const AssetsChartLegendWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;

const LegendItemWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};

  &:not(:last-child) {
    margin-right: ${({ theme }) => theme.spacing(6)};
  }
`;

const LegendItemDot = styled.div<{ bgColor: string }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${({ bgColor }) => bgColor};
`;

interface LegendItemProps {
  color: string;
  name: string;
}

const LegendItem = (props: LegendItemProps) => {
  const { color, name } = props;
  return (
    <LegendItemWrapper>
      <LegendItemDot bgColor={color} />{" "}
      <Typography variant="body3" color="textSecondary">
        {name}
      </Typography>
    </LegendItemWrapper>
  );
};

export const AssetsChartLegend = () => {
  const { t } = useTranslation();
  const colors = useChartColors("assetsChart");

  return (
    <AssetsChartLegendWrapper>
      <LegendItem
        color={colors.investments}
        name={t("general.chart.assetsChart.legend.investments")}
      />
      <LegendItem
        color={colors.cash}
        name={t("general.chart.assetsChart.legend.cash")}
      />
    </AssetsChartLegendWrapper>
  );
};
